export default "__VITE_ASSET__C8Ga3Gg___"